import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
import './styles/dark-mode-overrides.css';
import './styles/pwa.css';
import './styles/scrollbar-hide.css';

// Error tracking has been removed
// Using internal error logging only

// Only register service worker in supported environments
if ('serviceWorker' in navigator && !window.navigator.userAgent.includes('StackBlitz')) {
  try {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');
        if (import.meta.env.DEV) {
          console.log('Service Worker registered with scope:', registration.scope);
        }
      } catch (error) {
        console.warn('Service Worker registration failed:', error);
        
        // Notify user of offline functionality limitations if appropriate
        if (navigator.onLine === false) {
          // You could dispatch an event or use a notification system here
          const event = new CustomEvent('service-worker-error', { 
            detail: { message: 'Offline functionality may be limited' } 
          });
          window.dispatchEvent(event);
        }
      }
    });
  } catch (error) {
    console.warn('Failed to setup Service Worker:', error);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {import.meta.env.PROD ? (
      <ErrorBoundary 
        componentName="AppRoot"
        fallback={<div className="error-fallback">
          <h2>Something went wrong</h2>
          <p>The application encountered an unexpected error. Please try refreshing the page.</p>
          <button onClick={() => window.location.reload()}>Refresh Page</button>
        </div>}>
        <App />
      </ErrorBoundary>
    ) : (
      <App />
    )}
  </StrictMode>
);